// ========== src/pages/EmailVerification.jsx ==========

import { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const EmailVerification = () => {
    const [searchParams] = useSearchParams();
    const [status, setStatus] = useState('verifying'); // verifying, success, error
    const [message, setMessage] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        const verifyEmail = async () => {
            const token = searchParams.get('token');

            if (!token) {
                setStatus('error');
                setMessage('Patvirtinimo nuoroda yra neteisinga.');
                return;
            }

            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/api/v1/auth/verify-email`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ token })
                });

                const data = await response.json();

                if (response.ok) {
                    setStatus('success');
                    setMessage(data.message);
                } else {
                    setStatus('error');
                    setMessage(data.detail || 'Patvirtinimas nepavyko.');
                }
            } catch (err) {
                console.error('Verification error:', err);
                setStatus('error');
                setMessage('Nepavyko prisijungti prie serverio.');
            }
        };

        verifyEmail();
    }, [searchParams]);

    return (
        <div className="min-h-screen bg-gradient-to-br from-purple-50 via-pink-50 to-blue-50 flex items-center justify-center p-4">
            <div className="max-w-md w-full bg-white rounded-3xl shadow-2xl p-8">
                <div className="text-center">
                    {status === 'verifying' && (
                        <>
                            <div className="text-6xl mb-4">⏳</div>
                            <h1 className="text-3xl font-bold text-gray-800 mb-4">Tikrinamas el. paštas...</h1>
                            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-500 mx-auto"></div>
                        </>
                    )}

                    {status === 'success' && (
                        <>
                            <div className="text-6xl mb-4">✅</div>
                            <h1 className="text-3xl font-bold text-gray-800 mb-4">El. paštas patvirtintas!</h1>
                            <p className="text-gray-600 mb-6">{message}</p>
                            <button
                                onClick={() => navigate('/login')}
                                className="w-full py-4 bg-gradient-to-r from-purple-500 to-pink-500 text-white rounded-xl font-bold text-lg shadow-lg hover:shadow-xl transition transform hover:scale-105"
                            >
                                Prisijungti
                            </button>
                        </>
                    )}

                    {status === 'error' && (
                        <>
                            <div className="text-6xl mb-4">❌</div>
                            <h1 className="text-3xl font-bold text-gray-800 mb-4">Patvirtinimas nepavyko</h1>
                            <p className="text-red-600 mb-6">{message}</p>
                            <div className="space-y-3">
                                <button
                                    onClick={() => navigate('/register')}
                                    className="w-full py-4 bg-gradient-to-r from-purple-500 to-pink-500 text-white rounded-xl font-bold text-lg shadow-lg hover:shadow-xl transition transform hover:scale-105"
                                >
                                    Registruotis iš naujo
                                </button>
                                <button
                                    onClick={() => navigate('/login')}
                                    className="w-full py-4 bg-gray-200 text-gray-700 rounded-xl font-bold text-lg hover:bg-gray-300 transition"
                                >
                                    Grįžti į prisijungimą
                                </button>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default EmailVerification;
